// import { State, Country } from "country-state-city";
import { countryOptions, stateOptions } from "./filters";

// export const STATE_OPTIONS = (country?: string) => [
//   { value: "all", label: "All States" },
//   ...State.getStatesOfCountry(country || "NG").map((state) => ({
//     value: state.isoCode,
//     label: state.name,
//   })),
// ];

// export const COUNTRY_OPTIONS = [
//   { value: "all", label: "All Countries" },
//   ...Country.getAllCountries().map((country) => ({
//     value: country.isoCode,
//     label: country.name,
//   })),
// ];
export const COUNTRY_OPTIONS = countryOptions;
export const STATE_OPTIONS = stateOptions;

export const HOME_PAGE = "/home";
export const SIGNIN_PAGE = "/signin";
export const LANDING_PAGE = "/";

export const ROUTES = {
  HOME: "/home",
  SIGNIN: "/signin",
  LANDING: "/",
  VERIFY: "/verify",
  ORDERS: "/home/orders",
  PROFILE: "/home/me",
  PROFILE_UPDATE: "/home/me/update",
  LISTINGS: "/home/listings",
  WALLET: "/home/wallet",
  SETTINGS: "/home/settings",
  RATINGS: "/home/ratings",
  REFERRALS: "/home/referrals",
} as const;

export const PUBLIC_ROUTES = ["/signin", "/signup", "/"];

export const ENDPOINTS = {
  LISTING: "/public/crop-listings/slug",
  LISTINGS: "/public/crop-listings",
} as const;

// Single source of truth so the UK office address never drifts out of sync
// across the buyer/seller/admin footers and the wallet receipt again.
export const COMPANY_UK_ADDRESS =
  "1 White Hall Road, Gateshead, United Kingdom NE8 4EQ";

export * from "./config";

export const KYC_STATUSES = {
  CREATED: "created",
  IN_REVIEW: "in-review",
  SUBMITTED: "submitted",
  VERIFIED: "verified",
  REJECTED: "rejected",
} as const;

export type KycStatus = (typeof KYC_STATUSES)[keyof typeof KYC_STATUSES];

// Statuses that should redirect to /verify
export const PENDING_KYC_STATUSES: KycStatus[] = [
  KYC_STATUSES.CREATED,
  KYC_STATUSES.REJECTED,
];

// Statuses that can access but see banner
export const REVIEW_KYC_STATUSES: KycStatus[] = [
  KYC_STATUSES.IN_REVIEW,
  KYC_STATUSES.SUBMITTED,
];
